import {
  EntityDropdownInput,
  EntityDropdownProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInput";
import {
  FlowAdapter,
  type FlowAttributeReferenceType,
} from "@validereinc/domain";
import React from "react";

export const ProductTypeDropdownInput = ({
  name = "product_type",
  label,
  ...props
}: Omit<
  EntityDropdownProps<FlowAttributeReferenceType[]>,
  "fetchEntityList"
>) => {
  return (
    <EntityDropdownInput
      fetchEntityList={FlowAdapter.productTypes.getList}
      label={label ?? "Product Type"}
      name={name}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...props}
    />
  );
};
